import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PaymentMethod, REDUX_STORE_SLICES } from '../../services/exports/Constants';

export default createSlice({
  name: REDUX_STORE_SLICES.PAYMENT_FLOW,
  initialState: {
    selectedPaymentMethod: null,
  },
  reducers: {
    setSelectedPaymentMethod: (state, action: PayloadAction<PaymentMethod>) => {
      state.selectedPaymentMethod = action.payload;
    },
  },
});

export const props = (state) => state;
